import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { authReducer } from '@/store/slices/authSlice';
import { locationReducer } from '@/store/slices/locationSlice';
import { searchReducer } from '@/store/slices/searchSlice';
import { gradientReducer } from '@/store/slices/gradientSlice';
import { subscriptionReducer } from '@/store/slices/subscriptionSlice';
import uiReducer from '@/store/slices/uiSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    location: locationReducer,
    search: searchReducer,
    gradient: gradientReducer,
    subscription: subscriptionReducer,
    ui: uiReducer,
  },
  devTools: true
});

export default store;

// #region React DevTools Configuration
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {auth: AuthState, location: LocationState, search: SearchState}
export type AppDispatch = typeof store.dispatch;

// Create typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// #endregion
